import { atom } from 'recoil';
import User, { UserLoginState } from '../../2_domain/user/user';

const userAtom = atom<User>({
  key: 'appUserAtomKey',
  default: { email: '', loginState: UserLoginState.default },
});

export default userAtom;
